import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import { api } from '../../services/api';
/* import { withAuthenticationRequired } from '@auth0/auth0-react'; */
import DeleteStaffModal from "../../components/modales/DeleteStaffModal";
import VolverButton from "../../components/VolverButton";
import { Alert, Button, Chip, CircularProgress, Container, FormControl, IconButton, Menu, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { Check, Close, Delete, DownloadOutlined, Edit, MoreVert } from '@mui/icons-material';
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";
import { toast, Bounce } from 'react-toastify';

const Staff = () => {
  const [evento, setEvento] = useState(null);
  const param = useParams();
  const [email, setEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [staffMembers, setStaffMembers] = useState([]);
  const [subrol, setSubrol] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [editingMember, setEditingMember] = useState(null);
  const [editedRole, setEditedRole] = useState(null);
  const [editedSubrole, setEditedSubrole] = useState(null);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);

  // estados para modal de eliminacion
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);

  const [loading, setLoading] = useState(true);

  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: "success"
  });

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast({ ...toast, open: false });
  }

  const handleMenuOpen = (event, member) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedMember(member);
  }

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  }

  // manejo para eliminar un usuario
  const handleDeleteMember = () => {
    if (selectedMember) {
      let memberType = '';

      switch (selectedMember.rolTipo) {
        case 'Owner':
          memberType = 'owner';
          break;
        case 'Cliente':
          memberType = 'cliente';
          break;
        case 'Expositor':
          memberType = 'expositor';
          break;
        case 'Vendedor':
          memberType = 'vendedor';
          break;
        case 'Tesorero':
          memberType = 'tesorero';
          break;
        default:
          memberType = 'colaborador'; // Para todos los tipos de colaboradores
          break;
      }

      setMemberToDelete({
        id: selectedMember.id,
        type: memberType,
        name: getMemberName(selectedMember)
      });

      setDeleteModalOpen(true);
      handleMenuClose();


    }
  };

  const handleDeleteSuccess = async () => {
    setDeleteModalOpen(false);
    setMemberToDelete(null);

    setToast({
      open: true,
      message: 'Miembro eliminado correctamente',
      severity: 'success'
    });

    fetchEventData(false);

  };

  const handleDeleteError = (errorMsg) => {
    setToast({
      open: true,
      message: `Error al eliminar: ${errorMsg || 'Error desconocido'}`,
      severity: 'error'
    });
  };

  // manejo de edicion de subrol
  const handleEdit = () => {
    if (selectedMember && isEditableRole(selectedMember.rolId)) {
      setEditingMember(selectedMember.id);
      if (selectedMember.rolId === 9) {
        setEditedRole('vendedor');
        setEditedSubrole(null);
      } else if ([2, 5, 6, 7].includes(selectedMember.rolId)) {
        setEditedRole('colaborador');

        let subrolValue;
        switch (selectedMember.rolId) {
          case 2: subrolValue = 0; break; // Colaborador General
          case 5: subrolValue = 2; break; // Control de Acceso
          case 6: subrolValue = 3; break; // Control de Voucher
          case 7: subrolValue = 7; break; // Administrador de datos
          default: subrolValue = 0;
        }
        setEditedSubrole(subrolValue);
      }

      handleMenuClose();
    } else {
      setToast({
        open: true,
        message: 'Solo se pueden editar roles de colaboradores y vendedores',
        severity: 'info'
      });
      handleMenuClose();
    }
  };

  const isEditableRole = (rolId) => {
    const editableRoleIds = [2, 5, 6, 7, 9]; // Colaboradores y vendedor
    return editableRoleIds.includes(parseInt(rolId));
  };

  const handleCancelEdit = () => {
    setEditingMember(null);
    setEditedRole('');
    setEditedSubrole(null);
  };

  const handleSaveEdit = async (member) => {
    try {
      let nuevoIdRol;
      let nuevoSubrol = 0;

      if (editedRole === 'vendedor') {
        nuevoIdRol = 9;
        nuevoSubrol = 0; // los vendedores no tienen subrol
      } else if (editedRole === 'colaborador') {
        switch (parseInt(editedSubrole)) {
          case 0: nuevoIdRol = 2; break; // Colaborador General
          case 2: nuevoIdRol = 5; break; // Control de Acceso
          case 3: nuevoIdRol = 6; break; // Control de Voucher
          case 7: nuevoIdRol = 7; break; // Administrador de datos
          default: nuevoIdRol = 2;
        }
        nuevoSubrol = parseInt(editedSubrole);
      }

      if (member.rolId === nuevoIdRol) {
        handleCancelEdit();
        return;
      }

      setSubmitting(true);

      const response = await api.participaciones.updateSubrol({
        idparticipacion: member.id,
        newRol: nuevoIdRol,
        newSubrol: nuevoSubrol
      });

      if (response.status === "success") {

        handleCancelEdit();
        setSubmitting(false);

        setToast({
          open: true,
          message: 'Rol actualizado correctamente',
          severity: 'success'
        });

        fetchEventData(false);


        /* setStaffMembers(prevMembers =>
          prevMembers.map(m =>
            m.id === member.id
              ? {
                ...m,
                rolId: nuevoIdRol,
                rolTipo: editedRole === 'vendedor' ? 'Vendedor' : 'Colaborador'
              }
              : m
          )
        ); */

      } else {
        throw new Error(response.message || "Error al actualizar el rol");
      }
    } catch (error) {
      setError("Error actualizando el rol: " + error.message);
      setSubmitting(false);

      setToast({
        open: true,
        message: 'Error al actualizar el rol: ' + error.message,
        severity: 'error'
      });
    }
  };

  //paginacion
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  const displayedStaffMembers = staffMembers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const fetchEventData = async (showLoading = true) => {
    if (showLoading) setLoading(true);
    try {
      const responseEvento = await api.eventos.get(param.id);
      if (responseEvento.status === "success") {
        setEvento(responseEvento.data.evento);
        /* console.log("responseEvento", responseEvento); */

        const responseParticipaciones = await api.participaciones.getParticipacionesByEvento(param.id);
        if (responseParticipaciones.status === "success") {
          /* console.log("responseParticipaciones", responseParticipaciones); */
          const participaciones = responseParticipaciones.data.participaciones.map(p => {
            const isCollab = [2, 5, 6, 7].includes(p.idrol);
            return {
              id: p.id,
              idusuario: p.idusuario,
              idrol: p.idrol,
              rolTipo: isCollab ? "Colaborador" : (p.rol?.rol || obtenerNombreRol(p.idrol)),
              nombreUsuario: p.usuario?.usuario || "",
              nombre: p.usuario?.nombre || "",
              apellido: p.usuario?.apellido || "",
              idestado: 2,
              rolId: p.idrol,
              estado: {
                idestado: 2,
                estado: "Aceptado"
              }
            };
          });

          setStaffMembers(participaciones);
          if (participaciones?.length <= page * rowsPerPage) {
            setPage(0);
          }
        } else {
          setError("Error al cargar las participaciones: " + responseParticipaciones.message);
        }
      } else {
        setError(responseEvento.message || "Error al cargar el evento");
      }
    } catch (error) {
      setError(error.message || "Error al cargar los datos del evento");
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  useEffect(() => {
    fetchEventData(true);
    document.title = `Staff | PassGo`;
  }, [param.id]);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const response = await api.participaciones.getParticipaciones();
        if (response.status === "success") {
          const rol = response.data.participaciones.find(
            (p) => p.idevento == param.id
          )?.idrol;
          setUserRole(rol);
        } else {
          setError("Error al obtener el rol.");
        }
      } catch (error) {
        setError("Error en la red.");
      }
    };
    fetchRole();
  }, [param.id]);

  const obtenerNombreRol = (idRol) => {
    switch (idRol) {
      case 1: return "Owner";
      case 2: return "Colaborador General";
      case 3: return "Cliente";
      case 5: return "Control de Acceso";
      case 6: return "Control de Voucher";
      case 7: return "Administrador de datos";
      case 8: return "Expositor";
      case 9: return "Vendedor";
      case 10: return "Tesorero";
      default: return "Desconocido";
    }
  };

  const roleOptions = [
    { value: 'owner', label: 'Owner', description: 'Acceso completo a todas las funciones y configuraciones del evento.' },
    { value: 'cliente', label: 'Cliente', description: 'Acceso únicamente a reportes, estadísticas y seguimiento del evento' },
    { value: 'colaborador', label: 'Colaborador', description: 'Acceso limitado según el tipo de colaborador seleccionado.' },
    { value: 'expositor', label: 'Expositor', description: 'Permite registrar información de asistentes mediante el escaneo de sus tickets de ingreso.' },
    { value: 'vendedor', label: 'Vendedor', description: 'Usuario encargado de la venta presencial de tickets y/o vouchers.' },
    { value: 'tesorero', label: 'Tesorero', description: 'Usuario encargado de la gestión financiera del evento.' }
  ];

  // subroles de los colaboradores
  const colaboradorRoles = [
    {
      value: 0,
      label: "Colaborador General",
      description: "Rol encargado de diversas tareas como controlar el acceso y los vouchers."
    },
    {
      value: 2,
      label: "Control de Acceso",
      description: "Rol encargado de controlar el acceso de las personas autorizadas al evento."
    },
    {
      value: 3,
      label: "Control de Voucher",
      description: "Rol encargado de controlar y gestionar el canje de los vouchers del evento."
    },
    {
      value: 7,
      label: "Administrador de datos",
      description: "Rol encargado de la carga y diseño de tickets."
    }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSubmitted(false);

    if (!email) {
      setError("El correo electrónico es obligatorio");
      setSubmitting(false);
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Introduce un correo electrónico válido");
      setSubmitting(false);
      return;
    }

    if (!selectedRole) {
      setError("Debes seleccionar un rol");
      setSubmitting(false);
      return;
    }

    if (selectedRole === 'colaborador' && subrol === null) {
      setError("Debes seleccionar un tipo de colaborador");
      setSubmitting(false);
      return;
    }

    try {
      const verificarResponse = await api.usuarios.getUserExist(email);

      if (verificarResponse.status === "error") {
        setError("El usuario con este correo no está registrado. Por favor, indique al usuario que se registre primero.");
        setSubmitting(false);
        return;
      }

      const usuario = verificarResponse.data.usuario;

      let idRol;
      let subrolId = null;

      switch (selectedRole) {
        case 'owner':
          idRol = 1;
          break;
        case 'cliente':
          idRol = 3;
          break;
        case 'colaborador':
          subrolId = parseInt(subrol);

          if (subrolId === 0) idRol = 2;
          else if (subrolId === 2) idRol = 5;
          else if (subrolId === 3) idRol = 6;
          else if (subrolId === 7) idRol = 7;
          break;
        case 'expositor':
          idRol = 8;
          break;
        case 'vendedor':
          idRol = 9;
          break;
        case 'tesorero':
          idRol = 10;
          break;
        default:
          setError("Rol no válido");
          setSubmitting(false);
          return;
      }

      const participacionData = {
        idevento: parseInt(param.id),
        idusuario: usuario.id,
        idrol: idRol,
        email: email,
        subrol: subrolId
      };

      const response = await api.participaciones.createParticipacion(participacionData);

      if (response.status === "success") {
        setSubmitting(false);
        setSubmitted(true);
        setError("");
        setEmail("");
        setSelectedRole("");
        setSubrol(null);

        setToast({
          open: true,
          message: 'Usuario registrado correctamente',
          severity: 'success'
        });

        const emailData = {
          recipient: email,
          evento: evento.evento,
          rol: selectedRole
        };
        await api.email.send(emailData);

        fetchEventData(false);

        setTimeout(() => {
          setSubmitted(false);
        }, 1500);
      } else {
        setError("Error: " + response.message);
        setSubmitting(false);
      }
    } catch (error) {
      setError("Error: " + error.message);
      setSubmitting(false);
    }
  };


  const renderActionButton = (member) => {
    if (member.idestado === 3 || member.idestado === 4) {
      return null;
    }

    if (userRole === 1) {
      // si se esta editando un miembro, mostrar boton para guardar o cancelar los cambios
      if (editingMember === member.id) {
        return (
          <div className="d-flex justify-content-end">
            <IconButton
              onClick={() => handleSaveEdit(member)}
              disabled={submitting}
              sx={{ color: '#5656ff' }}
            >
              <Check />
            </IconButton>
            <IconButton
              onClick={handleCancelEdit}
              sx={{ color: '#FF5656' }}
            >
              <Close />
            </IconButton>
          </div>
        );
      }

      // si no se esta editando, se muestra el menu
      return (
        <>
          <IconButton
            aria-label="opciones"
            onClick={(e) => handleMenuOpen(e, member)}
            sx={{ color: '#5656ff' }}
          >
            <MoreVert />
          </IconButton>
        </>
      );
    }

    return null;
  };

  const renderMenu = () => {
    return (
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
            borderRadius: '5px',
          },
          '& .MuiMenuItem-root': {
            fontFamily: 'Bricolage Grotesque',
            fontSize: '16px',
            padding: '8px 16px',
          }
        }}
      >
        <MenuItem
          onClick={handleEdit}
          disabled={!isEditableRole}
          sx={{
            opacity: isEditableRole ? 1 : 0.5,
            '&.Mui-disabled': {
              color: '#9e9e9e',
            }
          }}
        >
          <Edit sx={{ marginRight: "10px", color: isEditableRole ? "#5656ff" : "#9e9e9e" }} />
          Editar rol
        </MenuItem>
        <MenuItem onClick={handleDeleteMember}>
          <Delete sx={{ marginRight: "10px", color: "#FF5656" }} />
          Eliminar
        </MenuItem>
      </Menu>
    );
  };


  const renderRolCell = (member) => {
    if (editingMember === member.id && isEditableRole(member.rolId)) {
      return (
        <div>
          {/* Selector de tipo de rol */}
          <FormControl size="small" fullWidth sx={{ mb: 1 }}>
            <Select
              value={editedRole}
              onChange={(e) => {
                setEditedRole(e.target.value);
                if (e.target.value === 'vendedor') {
                  setEditedSubrole(null);
                } else if (e.target.value === 'colaborador') {
                  setEditedSubrole(0);
                }
              }}
              sx={{
                fontFamily: "Bricolage Grotesque",
                height: '32px',
                '.MuiSelect-select': {
                  padding: '4px 10px',
                }
              }}
            >
              <MenuItem value="colaborador">Colaborador</MenuItem>
              <MenuItem value="vendedor">Vendedor</MenuItem>
            </Select>
          </FormControl>

          {/* Selector de subrol (solo si es colaborador) */}
          {editedRole === 'colaborador' && (
            <FormControl size="small" fullWidth>
              <Select
                value={editedSubrole}
                onChange={(e) => setEditedSubrole(e.target.value)}
                sx={{
                  fontFamily: "Bricolage Grotesque",
                  height: '32px',
                  '.MuiSelect-select': {
                    padding: '4px 10px',
                  }
                }}
              >
                {colaboradorRoles.map((role) => (
                  <MenuItem key={role.value} value={role.value}>
                    {role.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div>
      );
    }

    return (
      <span>
        {isCollaboratorRole(member.rolId)
          ? getSubrolText(member.rolId)
          : member.rolTipo}
      </span>
    );
  };

  const isCollaboratorRole = (rolId) => {
    const collaboratorRoleIds = [2, 5, 6, 7];
    return collaboratorRoleIds.includes(parseInt(rolId));
  };

  const getMemberName = (member) => {
    // traigo el nombre y apellido del usuario
    return `${member.nombre || ""} ${member.apellido || ""}`.trim() ||
      "Desconocido";
  };

  const getMemberEmail = (member) => {
    return member.nombreUsuario ||
      "Desconocido";
  }

  const getSubrolText = (rolId) => {
    switch (parseInt(rolId)) {
      case 2: return "Colaborador General";
      case 5: return "Control de Acceso";
      case 6: return "Control de Voucher";
      case 7: return "Administrador de datos";
      default: return "General";
    }
  };

  const getStatusChip = (estado) => {
    let backgroundColor = '#E0E0E0';
    let textColor = '#757575';

    if (!estado) {
      return <Chip
        label="Desconocido"
        size="small"
        sx={{
          bgcolor: backgroundColor,
          color: textColor,
          fontWeight: 500,
          minWidth: '80px'
        }}
      />;
    }

    if (estado.estado === "Aceptado" || estado.idestado === 1) {
      backgroundColor = '#B6FECB';
      textColor = '#216735';
    }

    return <Chip
      label={estado.estado || "Desconocido"}
      size="small"
      sx={{
        bgcolor: backgroundColor,
        color: textColor,
        fontWeight: 500,
        minWidth: '80px',
        fontFamily: "Bricolage Grotesque"
      }}
    />;
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
    @keyframes pulse {
      0% {
        opacity: 0.6;
      }
      50% {
        opacity: 0.3;
      }
      100% {
        opacity: 0.6;
      }
    }
  `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  /* const handleDescargarReporteParticipantes = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteParticipantes(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_participantes_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      setToast({
        open: true,
        message: 'La descarga ha comenzado correctamente',
        severity: 'success'
      });

    } catch (error) {
      console.error('Error al descargar el reporte:', error);

      setToast({
        open: true,
        message: 'Error al descargar el reporte: ' + (error.message || 'Error desconocido'),
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  }; */

  return (
    <Container>
      {userRole === 1 && (
        <>
          <p className='mb-0' style={{ fontSize: "18px", fontWeight: "500", marginTop: "20px" }}>
            Correo electrónico
          </p>

          <form onSubmit={handleSubmit}>
            <TextField
              sx={{
                fontFamily: "Bricolage Grotesque",
                mb: 2,
                '& .MuiInputBase-input-MuiOutlinedInput-input': {
                  fontFamily: "Bricolage Grotesque",
                },
                '& label.Mui-focused': {
                  color: '#5656FF',
                  fontFamily: "Bricolage Grotesque"
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#B2BAC2',
                  },
                  '&:hover fieldset': {
                    borderColor: '#5656ff',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#5656ff',
                  },
                }
              }}
              type="email"
              name="email"
              id="email"
              placeholder="johndoe@gmail.com"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: false }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
            />

            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "500", marginTop: "20px" }}>
              Selecciona un rol para el miembro
            </p>

            <div className="row">
              {roleOptions.map((role) => (
                <div key={role.value} className="col-sm-6 col-md-4 mb-3">
                  <label
                    className={`w-100 role-card ${selectedRole === role.value ? 'active' : ''}`}
                    style={{
                      display: 'block',
                      border: selectedRole === role.value ? '1px solid #5656ff' : '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '16px',
                      background: selectedRole === role.value ? '#e6e6ff' : '#fff',
                      cursor: 'pointer',
                    }}
                  >
                    <input
                      type="radio"
                      name="role"
                      value={role.value}
                      checked={selectedRole === role.value}
                      onChange={() => {
                        setSelectedRole(role.value);
                        if (role.value !== 'colaborador') setSubrol(null);
                      }}
                      style={{ display: 'none' }}
                    />
                    <div className="d-flex align-items-start">
                      <div
                        className="custom-radio"
                        style={{
                          width: 18,
                          height: 18,
                          borderRadius: '50%',
                          border: '1px solid #5656ff',
                          marginRight: 12,
                          flexShrink: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {selectedRole === role.value && (
                          <div
                            style={{
                              width: 10,
                              height: 10,
                              borderRadius: '50%',
                              backgroundColor: '#5656ff',
                            }}
                          />
                        )}
                      </div>
                      <div>
                        <div style={{ fontWeight: 'bold', color: "#0b0060" }}>{role.label}</div>
                        <div style={{ fontSize: '13px', color: '#555' }}>{role.description}</div>
                      </div>
                    </div>
                  </label>
                </div>
              ))}
            </div>

            {selectedRole === 'colaborador' && (
              <FormControl fullWidth margin="normal">
                <Typography variant="subtitle1" gutterBottom>
                  Selecciona un tipo de colaborador
                </Typography>
                <div className="row">
                  {colaboradorRoles.map((role) => (
                    <div key={role.value} className="col-sm-6 col-md-3 mb-3">
                      <button
                        type="button"
                        onClick={() => setSubrol(role.value)}
                        className={`w-100 boton-tipo ${subrol === role.value ? 'boton-tipo-active' : ''}`}
                        style={{
                          border: subrol === role.value ? '1px solid #5656ff' : '1px solid #ccc',
                          borderRadius: '4px',
                          padding: '10px',
                          background: subrol === role.value ? '#e6e6ff' : 'white',
                          cursor: 'pointer',
                          textAlign: 'left',
                          height: '100%',
                        }}
                      >
                        <div className='d-flex flex-column'>
                          <span className="d-flex align-items-center" style={{ fontWeight: "bold" }}>
                            {role.label}
                          </span>
                          <span style={{ fontSize: "13px" }}>{role.description}</span>
                        </div>
                      </button>
                    </div>
                  ))}
                </div>
              </FormControl>
            )}

            {submitting && (
              <Alert icon={false} severity="info" className="mb-3">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <CircularProgress size="30px" />
                  Estamos verificando el correo ingresado. Por favor espera unos momentos.
                </div>
              </Alert>
            )}

            {error && <Alert severity="error" className="mb-3">{error}</Alert>}

            {submitted && (
              <Alert icon={<Check fontSize="inherit" />} severity="success" className="mb-3">
                Se ha enviado una invitación al correo electrónico proporcionado.
              </Alert>
            )}

            <div className="d-flex justify-content-end mt-3">
              <button
                type="submit"
                style={{
                  backgroundColor: evento?.id_estados_eventos === 4 || submitting || !email || !selectedRole || (selectedRole === 'colaborador' && subrol === null)
                    ? "#9999ff"
                    : "#5656FF",
                  color: "white",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  cursor: evento?.id_estados_eventos === 4 || submitting || !email || !selectedRole || (selectedRole === 'colaborador' && subrol === null)
                    ? "not-allowed"
                    : "pointer",
                  opacity: evento?.id_estados_eventos === 4 || submitting || !email || !selectedRole || (selectedRole === 'colaborador' && subrol === null)
                    ? "0.7"
                    : "1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: window.innerWidth <= 576 ? "14px" : "16px",
                  border: "none",
                  outline: "none",
                }}
                disabled={evento?.id_estados_eventos === 4}
              >
                Registrar usuario
              </button>
            </div>
          </form>
        </>
      )}

      <div className="d-flex align-items-center justify-content-between mt-4">
        <Typography variant="h6" component="h2" gutterBottom mt={4} mb={2} sx={{
          fontFamily: "Bricolage Grotesque",
          color: "#0B0060",
          fontSize: "20px",
          fontWeight: "600"
        }}>
          Miembros del Staff
        </Typography>
        {/* <Button
          variant="outlined"
          onClick={handleDescargarReporteParticipantes}
          disabled={loading}
          sx={{
            ml: 2,
            borderColor: "#3d2eab",
            color: "#3D2EAB",
            padding: "10px",
            "&:hover": {
              borderColor: "#2d2180",
              backgroundColor: "rgba(61, 46, 171, 0.04)"
            }
          }}
        >
          {loading ? <CircularProgress size={24} /> : <DownloadOutlined />}
        </Button> */}
      </div>

      <TableContainer component={Paper} className="mt-3">
        <Table aria-label="staff table">
          <TableHead sx={{ backgroundColor: "#E6E6FF" }}>
            <TableRow sx={{ borderColor: "#E6E6FF", textAlign: "center" }}>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>Usuario</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>Email</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", textAlign: "center" }}>Rol</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", textAlign: "center" }}>Estado</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              Array(5).fill(0).map((_, index) => (
                <TableRow key={`skeleton-${index}`}>
                  <TableCell>
                    <div style={{
                      backgroundColor: '#f0f0f5',
                      height: '24px',
                      width: '80%',
                      borderRadius: '4px',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }}></div>
                  </TableCell>
                  <TableCell>
                    <div style={{
                      backgroundColor: '#f0f0f5',
                      height: '24px',
                      width: '90%',
                      borderRadius: '4px',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }}></div>
                  </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    <div style={{
                      backgroundColor: '#f0f0f5',
                      height: '24px',
                      width: '60%',
                      margin: '0 auto',
                      borderRadius: '4px',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }}></div>
                  </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    <div style={{
                      backgroundColor: '#f0f0f5',
                      height: '24px',
                      width: '70%',
                      margin: '0 auto',
                      borderRadius: '4px',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }}></div>
                  </TableCell>
                  <TableCell align="right">
                    <div style={{
                      backgroundColor: '#f0f0f5',
                      height: '24px',
                      width: '24px',
                      borderRadius: '50%',
                      float: 'right',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }}></div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              staffMembers?.length > 0 ? (
                displayedStaffMembers.map((member, index) => (
                  <TableRow key={`${member.rolTipo}-${member.id}-${index}`} hover>
                    <TableCell className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                      {getMemberName(member)}
                    </TableCell>
                    <TableCell className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                      {getMemberEmail(member)}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "Bricolage Grotesque", textAlign: "center" }}>
                      {renderRolCell(member)}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{getStatusChip(member.estado)}</TableCell>
                    <TableCell align="right">{renderActionButton(member)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="5" align="center" sx={{ py: 4 }}>
                    <Alert severity="info" sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      fontFamily: "Bricolage Grotesque"
                    }}>
                      No hay miembros de staff registrados
                    </Alert>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        {!loading && staffMembers.length > 0 && (
          <TablePagination
            component="div"
            className="d-flex justify-content-center"
            rowsPerPageOptions={[5, 10, 25, 50]}
            count={staffMembers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Registros p/página"
            showFirstButton
            showLastButton
            sx={{
              fontFamily: "Bricolage Grotesque",
              '& .MuiToolbar-root': {
                color: '#71717A',
              },
              '& .MuiButtonBase-root': {
                color: '#0B0060',
              },
              '& .Mui-disabled': {
                color: '#B5BABF',
              }
            }}
          />
        )}
      </TableContainer>

      {/* Menu de opciones */}
      {renderMenu()}

      {/* Modal para eliminar */}
      {memberToDelete && (
        <DeleteStaffModal
          isOpen={deleteModalOpen}
          toggle={() => setDeleteModalOpen(false)}
          id={memberToDelete.id}
          memberType={memberToDelete.type}
          memberName={memberToDelete.name}
          onSuccess={handleDeleteSuccess}
          onError={handleDeleteError}
        />
      )}

      {/* Toast */}
      <Snackbar
        open={toast.open}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseToast}
          severity={toast.severity}
          variant="filled"
          sx={{
            width: '100%',
            fontFamily: 'Bricolage Grotesque'
          }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
        <VolverButton />
      </div>
    </Container>
  );
};

export default withAuthenticationRequired(Staff, {
  onRedirecting: () => <Loading />,
});